
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/materials/create",
      function () {
        return require("private-next-pages/materials/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/materials/create"])
      });
    }
  